<template>
  <f7-page @page:beforeremove="onPageBeforeRemove">
    <f7-popup class="demo-popup" :opened="popupOpened" @popup:closed="closePopup">
      <f7-page>
        <f7-navbar title="404, Page Not Found!">
          <f7-nav-right>
            <f7-link popup-close>Close</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block style="text-align:center">
          <img src="../../assets/404error.jpeg" />
          <br />
          <a :href="origin">{{origin}}</a>
        </f7-block>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>
<style scoped>
img {
  border: none !important;
}
</style>

<script>
export default {
  name: "PageNotFound",
  data() {
    return {
      popupOpened: true,
      origin: window.location.origin
    };
  },
  methods: {
    closePopup() {
      this.popupOpened = false;
      window.location.href = window.location.origin;
    },
    onPageBeforeRemove() {
      const self = this;
      // Destroy popup when page removed
      if (self.popup) self.popup.destroy();
    }
  }
};
</script>
